import { Pressable } from 'react-native';
import { InfoIcon } from '../../Icons/InfoIcon';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';

export function InfoText({
  title,
  text,
  showIcon = true,
  hasError = false,
  onPress,
  className,
}: {
  title: string;
  text: string;
  showIcon?: boolean;
  hasError?: boolean;
  onPress?: () => void;
  className?: string;
}) {
  return (
    <Pressable
      onPress={() => onPress?.()}
      className={cn(
        'flex-row items-center gap-1 active:opacity-20',
        className,
      )}>
      {showIcon && (
        <InfoIcon className={hasError ? 'fill-error' : 'fill-neutral-300'} />
      )}
      {title && (
        <Typography
          size="small"
          className={hasError ? 'text-error' : 'text-neutral-300'}>
          {title}
        </Typography>
      )}

      {text && (
        <Typography
          size="small"
          className={hasError ? 'text-error' : 'fill-white'}>
          {text}
        </Typography>
      )}
    </Pressable>
  );
}
